/**
 * Normalize values by converting undefined values to empty strings
 * Used for comparing form initial and current values
 */
export const normalizeValues = (value: any): any => {
  // Handle undefined values
  if (value === undefined) {
    return "";
  }

  // Handle null values
  if (value === null) {
    return null;
  }

  // Handle arrays
  if (Array.isArray(value)) {
    return value.map((item) => normalizeValues(item));
  }

  // Handle objects
  if (typeof value === "object") {
    const normalized: Record<string, any> = {};

    Object.keys(value).forEach((key) => {
      normalized[key] = normalizeValues(value[key]);
    });

    return normalized;
  }

  // Return primitives as-is
  return value;
};

/**
 * Compare two objects and determine if they have effective changes
 * Treats undefined and empty string as equivalent
 */
export const hasFormChanges = (
  initialValues?: Record<string, any>,
  currentValues?: Record<string, any>,
): boolean => {
  if (!initialValues || !currentValues) {
    return false;
  }

  const normalizedInitial = normalizeValues(initialValues);
  const normalizedCurrent = normalizeValues(currentValues);

  return (
    JSON.stringify(normalizedInitial) !== JSON.stringify(normalizedCurrent)
  );
};
